import BaseClient from '@/app/model/api/response/baseApiClient'

class NewsBoardCreateApi extends BaseClient {
  public doNewsBoardCreate (bodyData: any) {
    const path:string = '/v1/news-boards'

    /* 共通処理 */
    return super.setBody(JSON.stringify(bodyData)).doFetch(process.env.VUE_APP_API_URL + path, 'POST')
  }
}

export default new NewsBoardCreateApi()
